import { tm } from '@captaincause/ui/tm'
import { SmallFooter } from 'components/SmallFooter'
import type { LayoutProps } from './App'

export function SmallFooterLayout({ children, className = '' }: LayoutProps) {
  return (
    <div id="layout" className={tm('grid grid-rows-[1fr_auto]', className)}>
      {children}
      <SmallFooter />
    </div>
  )
}
